import styled from 'styled-components';
import {flexAdaptiveSizeItem} from "../../../../../themes/architecture/css-helpers/flex";


export const SectionTitleDefaultBox = styled.div`
    position: relative;
    min-width: 28rem;
    max-width: 82.5%;
    text-transform: uppercase;
    padding: 1rem 2rem 1rem 0.8rem;
    font-size: 1.2rem;
    line-height: normal;
    background: ${props => props.theme.components.generalTitle.colors.background};
    border-left: 2px solid ${props => props.theme.colors.textLight};
    color: ${props => props.theme.colors.textLight};
    ${({theme}) => theme.font.presets.bold};
    margin: 0 0 10px 0;
    @media ${({theme}) => theme.mediaQuery.xlAndBelow} {
      padding: .9rem 2rem;
    }
    
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        min-width: 65%;
        max-width: 100%;
        padding: 0.8rem 2rem;
        font-size: 1.4rem;
    }
    
    @media ${({theme}) => theme.mediaQuery.sAndBelow} {
      ${flexAdaptiveSizeItem}
      min-width: 0;
    }  
    
`;